'use strict';

const set = Symbol('op:keyed.set');
const add = Symbol('op:collection.add');
const rem = Symbol('op:collection.rem');

module.exports = {
  set,
  add,
  rem,
};



// WEBPACK FOOTER //
// ./lib/rlink-collections/operations.js